export default {
  nav: {
    solutions: '解决方案',
    cases: '项目案例',
    kol: 'KOL合作',
    contact: '在线留言',
    login: '企业登录'
  },
  hero: {
    badge: 'AI驱动的实时音视频通信',
    title: '为全球游戏公司提供极致的实时通信体验',
    subtitle: '通过AI算法与WebRTC深度融合，为游戏厂商提供超低延迟、高清晰度的音视频解决方案，支持跨平台互动、实时语音翻译和智能画面优化',
    cta: '免费试用',
    learn: '了解更多',
    latency: '超低延迟',
    nodes: '全球节点',
    uptime: '可用性'
  },
  features: {
    title: '核心技术优势',
    subtitle: 'AI与WebRTC深度融合，为游戏通信提供极致体验',
    ai: {
      title: 'AI智能优化',
      desc: '智能降噪、回声消除、画面增强，确保清晰流畅的通信质量'
    },
    translate: {
      title: '实时语音翻译',
      desc: '支持多语言实时翻译，打破语言障碍，连接全球玩家'
    },
    global: {
      title: '全球节点覆盖',
      desc: '200+全球节点，智能路由选择，确保最低延迟和最佳连接质量'
    },
    security: {
      title: '企业级安全',
      desc: '端到端加密，数据安全可靠，符合国际隐私保护标准'
    }
  },
  solutions: {
    title: '解决方案',
    subtitle: '为不同游戏场景提供专业的音视频通信解决方案',
    streaming: {
      title: '游戏直播解决方案',
      desc: '为游戏主播提供超高清、低延迟的直播技术支持，支持百万级并发观看，实时互动零卡顿。AI智能美颜、滤镜效果，让直播画面更加精彩。',
      f1: '超高清4K直播，延迟低至25ms',
      f2: 'AI智能美颜和实时特效',
      f3: '支持百万级并发观看'
    },
    voice: {
      title: '团队语音解决方案',
      desc: '为MOBA、吃鸡等竞技游戏提供专业的团队语音通信，支持空间音频定位，让玩家精准判断队友位置。AI智能降噪，确保清晰通话。',
      f1: '3D空间音频，精准定位队友',
      f2: 'AI智能降噪，消除环境杂音',
      f3: '支持100人同时在线语音'
    },
    social: {
      title: '社交互动解决方案',
      desc: '为社交游戏提供多人视频通话、虚拟礼物、实时互动等功能。支持实时语音翻译，让不同国家的玩家无障碍交流。',
      f1: '多人视频通话，支持16人同屏',
      f2: '实时语音翻译，支持50+语言',
      f3: '虚拟礼物和互动特效'
    },
    acceleration: {
      title: '游戏加速解决方案',
      desc: '基于全球分布式节点和智能路由算法，为游戏提供网络加速服务，有效降低延迟和丢包率。支持多种游戏协议优化，确保玩家获得流畅的游戏体验。',
      f1: '智能路由，延迟降低60%以上',
      f2: '多协议优化，支持UDP/TCP加速',
      f3: '全球200+节点，就近接入'
    }
  },
  cases: {
    title: '成功案例',
    subtitle: '已为全球数百家游戏公司提供专业的音视频通信服务',
    moba: {
      title: 'MOBA竞技游戏',
      desc: '为某知名MOBA游戏提供全球赛事直播和团队语音服务，支持50万+并发用户，延迟低至18ms，确保电竞赛事流畅进行。',
      s1: '并发用户',
      s2: '平均延迟',
      s3: '可用性'
    },
    battle: {
      title: '大逃杀游戏',
      desc: '为吃鸡类游戏提供100人房间语音通信，3D空间音频让玩家精准判断敌人位置，AI降噪确保清晰通话，提升游戏竞技体验。',
      s1: '房间人数',
      s2: '语音延迟',
      s3: '用户满意度'
    },
    casual: {
      title: '社交休闲游戏',
      desc: '为社交游戏平台提供视频通话和直播服务，日活用户超100万，支持实时语音翻译，连接全球玩家，打造国际化社交体验。',
      s1: '日活用户',
      s2: '日均直播',
      s3: '留存率'
    }
  },
  kol: {
    title: 'KOL合作计划',
    subtitle: '诚邀游戏主播、内容创作者加入CM-Tong合作伙伴计划',
    b1: {
      title: '专属技术支持',
      desc: '提供专属技术团队支持，优先体验最新功能'
    },
    b2: {
      title: '收益分成',
      desc: '推广合作收益分成，共享平台发展红利'
    },
    b3: {
      title: '品牌曝光',
      desc: '官方渠道推广，提升个人品牌影响力'
    },
    b4: {
      title: '优先权益',
      desc: '优先参与平台活动，获得更多曝光机会'
    },
    cta: '立即申请合作'
  },
  contact: {
    title: '在线留言',
    subtitle: '填写您的需求，我们将在24小时内与您联系',
    name: '姓名',
    email: '邮箱',
    company: '公司名称',
    message: '留言内容',
    submit: '提交留言',
    submitting: '提交中...',
    success: '提交成功！我们会尽快与您联系'
  },
  login: {
    title: '企业登录',
    subtitle: '登录您的企业账号，开始使用CM-Tong平台',
    email: '企业邮箱',
    emailPlaceholder: '请输入企业邮箱',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    remember: '记住我',
    forgot: '忘记密码？',
    submit: '登录',
    noAccount: '还没有账号？',
    signup: '立即注册',
    back: '返回首页'
  },
  footer: {
    desc: 'CM-Tong是专业的AI+WebRTC音视频平台，为全球游戏公司提供高效、低延迟的实时通信解决方案。',
    product: '产品',
    company: '公司',
    rights: '版权所有'
  }
};
